export default __webpack_public_path__ + "static/hero_about_img_1-e850909406e7168b9dfba525e96f1aaa.png";